module.exports = __webpack_public_path__ + "img/blue-xmark.9e4414d4.svg";